import React from 'react';
import { TrendingUp, TrendingDown } from 'react-feather';
import { Card, CardBody } from 'reactstrap';
import { H6, H5 } from '../../../AbstractElements';
import SvgIcon from '../Component/SvgIcon';

const CurrencyWidget = ({ data, mainClass }) => {
  const isPositive = data.gros > 0;
  
  return (
    <div className={`currency-widget ${data.color} ${mainClass ? mainClass : ''}`}>
      <div className='d-flex'>
        <div className='currency-icon-widget'>
          <SvgIcon iconId={data.icon} />
        </div>
        <div>
          <H6>
            {data.title} <span className='f-light'>{data.sortName}</span>
          </H6>
        </div>
      </div>
      <Card>
        <CardBody>
          <div className='d-flex align-items-center justify-content-between mb-2'>
            <H5 attrH5={{ className: 'mb-0' }}>${data.price}</H5>
            <span className={`f-12 f-w-500 font-${isPositive ? 'success' : 'danger'}`}>
              {isPositive ? <TrendingUp className='me-1' size={14} /> : <TrendingDown className='me-1' size={14} />}
              {isPositive ? '+' : ''}{data.gros}%
            </span>
          </div>
          <div className='progress-showcase mt-2'>
            <div className='progress sm-progress-bar'>
              <div 
                className={`progress-bar bg-${data.color}`} 
                role='progressbar' 
                style={{ width: `${data.gros}%` }} 
                aria-valuenow={data.gros} 
                aria-valuemin='0' 
                aria-valuemax='100'
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default CurrencyWidget;
